import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, Subject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DialogUtils } from '../../crm/modules/agenda/helpers/dialog.utils';
import { Copy } from '../utils/deepcopy.utils';
import { GeneralQuery } from './general.query';
import { GeneralStore } from './general.store';

@Injectable({ providedIn: 'root' })
export class GeneralService {

  constructor(private generalStore: GeneralStore, private generalQuery: GeneralQuery, private router: Router, private http: HttpClient,
    private _overlay: Overlay, private injector: Injector) {
  }

  setMessageCount(messagesCount: number): void {
    this.generalStore.update({ messagesCount });
  }

  setMessagesIdToClose(messagesIdToClose: number): void {
    this.generalStore.update({ messagesIdToClose });
  }

  addNotification(notification: any): void {
    var notifications = this.generalQuery.notifications;
    var n = Copy.deep(notifications)
    n.push(notification);
    this.generalStore.update({ notifications: n });
  }

  removeNotification(notification: any) {
    var notifications = this.generalQuery.notifications;
    var n = Copy.deep(notifications)
    n = n.filter((c: any) => c.notification.title != notification.notification.title && c.notification.body != notification.notification.body);
    this.generalStore.update({ notifications: n });
  }

}
